"use strict";

const IncidentInvestigationSubmission = function () {
  const stringKey = "submission";
  const tabHeader = "Submission";
  let $page;

  var loadListeners = function (data) {
    $page = $(`#assessment-modal #${stringKey}`);

    $page.on("click", "[name='preview']", previewButtonClick);
    $page.on("2N:FormInput", "[name='isSiteRepPresent']", onIsSiteRepPresentChange);
    $page.on("2N:FormInput", "[name='start-time'], [name='end-time']", onStartOrEndDateChange);
    $page.on("2N:FormInput", "[name='materialsDistributed']", onMaterialsDistributedChange);
    $page.on("2N:FormInput", `[name="close-out-investigation"]`, onCloseOutInvestigationToggle);
    $page.on("2N:FormInput", "[name^='recommendedActions[']", onRecommendedActionChange);

    toggleFollowUp(data.closeOutInvestigation);
    toggleCloseOutFields(data.closeOutInvestigation);
    renderSummary(data);
  };

  var unloadListeners = function () {
    $page.off("click", "[name='preview']", previewButtonClick);
    $page.off("2N:FormInput", "[name='isSiteRepPresent']", onIsSiteRepPresentChange);
    $page.off("2N:FormInput", "[name='start-time'], [name='end-time']", onStartOrEndDateChange);
    $page.off("2N:FormInput", "[name='materialsDistributed']", onMaterialsDistributedChange);
    $page.off("2N:FormInput", `[name="close-out-investigation"]`, onCloseOutInvestigationToggle);
    $page.off("2N:FormInput", "[name^='recommendedActions[']", onRecommendedActionChange);
  };

  var getProps = function (data) {
    return {
      followUpInspectionTypeOptions:
        IncidentInvestigationConstants.getFollowUpInspectionTypeOptions(),
      materialTypeOptions: ToolSettings.getDomainOptions("material_type"),
      escalationActionOptions: BaseEnforcementAction().escalationActionOptions,
      enforcementEntityLabel: "incident",
      openEnforcements: data.openEnforcements ?? data.incidentInfo?.openEnforcements ?? [],
      recommendedActions: data.recommendedActions ?? {},
    };
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  var onIsSiteRepPresentChange = function (e, isSiteRepPresent) {
    const $fieldsContainer = $("#is-site-rep-present-field-container-js");
    $fieldsContainer.toggle(isSiteRepPresent);
    // Field data is conditionally nulled in the API
  };

  var previewButtonClick = async function () {
    return await InspectionPreview.preview(function () {
      const previewData = IncidentInvestigationController._getUpdateData();
      return previewData;
    }, ApiCalls.previewIncidentInvestigationPdf);
  };

  var onStartOrEndDateChange = function () {
    const startTime = $("[name='start-time']").val();
    const endTime = $("[name='end-time']").val();
    const $total = $("[name='total-investigation-time']");

    setDateRanges();
    if (startTime === "" || endTime === "") {
      $total.val("");
    } else {
      const minutes = Math.floor(
        (new Date(endTime) - new Date(startTime)) / (1000 * 60),
      ).toLocaleString("en-us");
      $total.val(minutes);
    }
  };

  var setDateRanges = function () {
    const startTime = $("[name='start-time']").val();
    const endTime = $("[name='end-time']").val();

    if (startTime) {
      DateTimePicker.setDatePickerRange($("#assessment-modal"), "end-time", false, startTime);
    }
    if (endTime) {
      DateTimePicker.setDatePickerRange($("#assessment-modal"), "start-time", true, endTime);
    }
  };

  var onMaterialsDistributedChange = function (e, materialsDistributed) {
    const $materialTypeField = $(".material-type");
    $materialTypeField.toggle(materialsDistributed);
  };

  var renderSummary = function (data) {
    $page
      .find("#js-incident-investigation-submission-summary")
      .html(IncidentInvestigationSummary.getSummaryHtml(data));
  };

  var toggleFollowUp = function (closeOutInvestigation) {
    $page.find("#js-incident-investigation-follow-up").toggle(!closeOutInvestigation);
    // IncidentInvestigationController.setFormData(["followUpInspection"], showFollowUp);
  };

  var tabShownCallback = function () {
    setDateRanges();
  };

  var onCloseOutInvestigationToggle = function (e, closeOutInvestigation) {
    toggleFollowUp(closeOutInvestigation);
    toggleCloseOutFields(closeOutInvestigation);
  };

  var toggleCloseOutFields = function (closeOutInvestigation) {
    $(".close-out-field").toggle(closeOutInvestigation);
  };

  var onRecommendedActionChange = function () {
    const recommendedActions = {};
    $("[name^='recommendedActions[']").each(function () {
      const $select = $(this);
      const $row = $select.closest("[data-enforcement-id]");
      const enforcementId = $row.data("enforcement-id");
      recommendedActions[enforcementId] = $select.val();
    });

    IncidentInvestigationController.setFormData(["recommendedActions"], recommendedActions);
  };

  return {
    loadListeners,
    unloadListeners,
    onStartOrEndDateChange,
    getStringKey,
    getTabHeader,
    getProps,
    renderSummary,
    tabShownCallback,
  };
};

module.exports = IncidentInvestigationSubmission();

const ApiCalls = require("../../apiCalls");
const IncidentInvestigationController = require("./incidentInvestigationController");
const IncidentInvestigationConstants = require("./incidentInvestigationConstants");
const InspectionPreview = require("../../general/inspectionPreview");
const ToolSettings = require("../../settings/toolSettings");
const IncidentInvestigationSummary = require("./incidentInvestigationSummary");
const DateTimePicker = require("../../general/dateTimePicker");
const BaseEnforcementAction = require("../../enforcement/baseEnforcementAction");
